<template>
  <div>
    <kendo-dropdownlist
      :data-source="yearDataSource"
      :data-text-field="'yearName'"
      :data-value-field="'year'"
      v-model="selectedYear"
      @databound="onYearDataBound"
      @change="onYearChange"
      style="width: 75px;"
    >
    </kendo-dropdownlist>
    <kendo-dropdownlist
      :data-source="periodDataSource"
      :data-text-field="'code'"
      :data-value-field="'periodId'"
      @databound="onPeriodDataBound"
      @change="onPeriodChange"
      :autoBind="false"
      style="width: 75px;"
    >
    </kendo-dropdownlist>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      selectedYear: -1,
      controlBound: false,
      yearDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/PeriodControl/getPeriodYears',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
              selectedPeriodId: this.selectedPeriodId,
              showAllYearItem: this.showAllYearItem,
            }),
            type: 'GET',
          },
        },
        schema: {
          data: response => {
            this.selectedYear = response.selectedYear
            return response.data
          },
        },
      }),
      periodDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/PeriodControl/getPeriods',
            contentType: 'application/json',
            data: () => ({
              year: this.selectedYear,
              clientId: this.clientId,
              showAllPeriodItem: this.showAllPeriodItem,
            }),
            type: 'GET',
          },
        },
      }),
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({selectedPeriodId: 'app/selectedPeriodId'}),
  },
  methods: {
    onYearDataBound(e) {
      if (this.selectedYear == -1) {
        e.sender.select(0)
      } else {
        e.sender.value(this.selectedYear)
      }
      this.selectedYear = e.sender.value()
      e.sender.trigger('change')
    },
    onYearChange(e) {
      this.selectedYear = e.sender.value()
      this.periodDataSource.read()
    },
    onPeriodDataBound(e) {
      let selectedPeriod = this.selectedPeriodId

      const selectedPeriodItem = e.sender.dataSource.data().filter(dataItem => {
        return dataItem.periodId == selectedPeriod
      })

      if (selectedPeriodItem.length < 1) {
        selectedPeriod = -1
        this.$store.dispatch('app/selectPeriod', {selectedPeriod})
      }

      if (selectedPeriod == -1) {
        e.sender.select(0)
      } else {
        if (this.controlBound) {
          e.sender.select(0)
        } else {
          e.sender.value(selectedPeriod)
        }
      }
      const periodId = +e.sender.value()
      const dataItem = e.sender.dataItem()
      const periodDataItem = {
        periodId: periodId,
        startDate: kendo.toString(dataItem.startDate, 'yyyy-MM-dd'),
        endDate: kendo.toString(dataItem.endDate, 'yyyy-MM-dd'),
        isVisible: dataItem.isVisible,
        isClosed: dataItem.isClosed,
      }
      this.$emit('input', periodId)
      this.$emit('change', periodDataItem)
      this.controlBound = true
    },
    onPeriodChange(e) {
      const periodId = +e.sender.value()
      const dataItem = e.sender.dataItem()
      const periodDataItem = {
        periodId: periodId,
        startDate: kendo.toString(dataItem.startDate, 'yyyy-MM-dd'),
        endDate: kendo.toString(dataItem.endDate, 'yyyy-MM-dd'),
        isVisible: dataItem.isVisible,
        isClosed: dataItem.isClosed,
      }
      this.$store.dispatch('app/selectPeriod', {periodId})
      this.$emit('input', periodId)
      this.$emit('change', periodDataItem)
    },
  },
  props: {
    value: {
      type: Number,
      required: false,
    },
    showAllYearItem: {
      type: Boolean,
      required: false,
      default: false,
    },
    showAllPeriodItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
